
import { computed, defineComponent, PropType } from 'vue'
import { RouteLocationRaw, useRouter } from 'vue-router'

/**
 * Ссылка на страницу админки в новой вкладке (из списка в карточку): обычный <a>, поэтому
 * работает и открытие средней кнопкой, и «копировать адрес ссылки».
 */
export default defineComponent({
  name: 'NewTabLink',
  props: {
    to: { type: [Object, String] as PropType<RouteLocationRaw>, required: true },
    /** Вид кнопки Element Plus: Open в списках. */
    button: { type: Boolean, default: false },
  },
  setup(props) {
    const router = useRouter()
    const href = computed(() => router.resolve(props.to).href)
    const linkClass = computed(() => (props.button ? 'el-button el-button--small' : ''))
    return { href, linkClass }
  },
})
